import React from 'react';
import Image from '../../../components/AppImage';

const TrustIndicators = () => {
  const trustedClients = [
  {
    id: 1,
    name: "Microsoft",
    logo: "https://images.unsplash.com/photo-1508878230531-f0fb65ca3007",
    alt: "Microsoft logo in blue and white corporate branding"
  },
  {
    id: 2,
    name: "Google",
    logo: "https://images.unsplash.com/photo-1662947190722-5d272f82a526",
    alt: "Google colorful logo with distinctive lettering"
  },
  {
    id: 3,
    name: "Amazon",
    logo: "https://images.unsplash.com/photo-1704204656144-3dd12c110dd8",
    alt: "Amazon logo with orange arrow from A to Z"
  },
  {
    id: 4,
    name: "IBM",
    logo: "https://images.unsplash.com/photo-1712833090470-4745c193663d",
    alt: "IBM blue corporate logo with horizontal stripes"
  }];


  const certifications = [
  {
    id: 1,
    name: "ISO 27001",
    badge: "https://images.unsplash.com/photo-1643101809136-ea076148efb6",
    alt: "ISO 27001 certification badge with security shield icon"
  },
  {
    id: 2,
    name: "SOC2 Type II",
    badge: "https://images.unsplash.com/photo-1727027629481-ede20919ebbb",
    alt: "SOC2 Type II compliance badge with checkmark symbol"
  },
  {
    id: 3,
    name: "GDPR Compliant",
    badge: "https://images.unsplash.com/photo-1723984993044-0ef58c8dfa89",
    alt: "GDPR compliance badge with EU flag colors and privacy shield"
  }];


  return (
    <div className="space-y-8">
      {/* Trusted by Enterprise Clients */}
      <div className="text-center">
        <h3 className="text-lg font-semibold text-foreground mb-6">
          Trusted by Leading Organizations
        </h3>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {trustedClients?.map((client) =>
          <div
            key={client?.id}
            className="flex items-center justify-center p-4 glass rounded-lg border border-white/10 hover:border-white/20 transition-all duration-300 group">

              <div className="w-20 h-10 overflow-hidden rounded">
                <Image
                src={client?.logo}
                alt={client?.alt}
                className="w-full h-full object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300" />

              </div>
            </div>
          )}
        </div>
      </div>
      {/* Security Certifications */}
      <div className="text-center">
        <h3 className="text-lg font-semibold text-foreground mb-6">
          Enterprise Security Standards
        </h3>
        <div className="flex justify-center space-x-6">
          {certifications?.map((cert) =>
          <div
            key={cert?.id}
            className="flex flex-col items-center space-y-2 p-3 glass rounded-lg border border-white/10 hover:border-success/30 transition-all duration-300">

              <div className="w-12 h-12 overflow-hidden rounded-lg">
                <Image
                src={cert?.badge}
                alt={cert?.alt}
                className="w-full h-full object-cover" />

              </div>
              <span className="text-xs font-medium text-text-secondary">
                {cert?.name}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>);

};

export default TrustIndicators;